import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Component, OnInit } from '@angular/core';
import { set } from 'lodash-es';
import { Datasource, GroupId, InputAttribute } from 'src/app/app.model';
import { ControlContainer, NgForm, NgModelGroup } from '@angular/forms';

@Component({
  selector: 'app-column-rows-renderer',
  templateUrl: './column-rows-renderer.component.html',
  styleUrls: ['./column-rows-renderer.component.scss'],
  viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class ColumnRowsRendererComponent implements ICellRendererAngularComp, OnInit {
  public data: any;
  public params: ICellRendererParams;
  public inputAttribute: any;
  currentSelection: { [key: string]: string[] } = {};
  selectedDatasource: Datasource = new Datasource();
  displayedSchemaColumns: string[] = [
    "schemaName",
    "unnesting",
    "primaryKey",
  ];
  gridApi: any;
;
  constructor() { }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.gridApi = params.api;
    this.data = params.node.data;
    this.inputAttribute = params.node.data;
    this.currentSelection = params.context.componentParent.currentSelection;
    this.selectedDatasource = params.context.componentParent.selectedDatasource;
  }
  
  ngOnInit(): void {
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  ifInterMediate(possibleValues: GroupId[]) {
    let count = 0;
    possibleValues.forEach((pValue) => {
      if (pValue.selected) {
        count++;
      }
    });

    if (count === possibleValues.length || count === 0) {
      return false;
    }

    return true;
  }
  
  onRowExpand(isOpened: boolean) {
    set(this.params, 'node.expanded', isOpened)
    const height = this.data?.possibleValues?.length * 48 + 150;
    this.params.node.setRowHeight(height);
    this.gridApi.onRowHeightChanged();
    console.log(`Node expanded ${this.params.data.label} - ${this.params.node.expanded}, ${height}`)
  }

  onRowClosed(isOpened: boolean) {
    set(this.params, 'node.expanded', isOpened)
    this.params.node.setRowHeight(81)
    this.gridApi.onRowHeightChanged();
    console.log(`Node expanded ${this.params.data.label} - ${this.params.node.expanded}, ${50}`)
  }

  onCheckBoxChangeAll($event, inputAttribute) {
    this.params.context.componentParent.onCheckBoxChangeAll($event, inputAttribute);
  }

  checkboxLabel(possibleValues: GroupId[], row?: GroupId): string {
    return this.params.context.componentParent.checkboxLabel(possibleValues, row);
  }

  selectionKey(inputAttribute) {
    return this.params.context.componentParent.selectionKey(inputAttribute);
  }

  onCheckBoxChanged(inputAttribute, value, event, triggerNotif, idx, childAttrFlag) {
    this.params.context.componentParent.onCheckBoxChanged(inputAttribute, value, event, triggerNotif, idx, childAttrFlag);
  }

  checkIfOneSelected(possibleValue, flag) {
    return this.params.context.componentParent.checkIfOneSelected(possibleValue, flag);
  }

  onReplicationClick(event) {
    this.params.context.componentParent.onReplicationClick(event);
  }

  onSelectValueChanged(
    inputAttribute: InputAttribute,
    parentAttribute: InputAttribute,
    event
  ) {
    this.params.context.componentParent.onSelectValueChanged(inputAttribute, parentAttribute, event);
  }

}
